import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { useStore, selectEditorState } from './store';
import { saveTabToStorage, saveToStorage } from './store/persist';
import './styles.css';

// Only the scratch document is persisted to localStorage. An open share is
// backed by the server, so persisting it would leak its content into the
// next plain "/" visit and produce accidental duplicates on Save.
let timer: number | undefined;
let lastTab: string | undefined;
useStore.subscribe((state) => {
  if (timer !== undefined) window.clearTimeout(timer);
  if (state.currentShare === null) {
    timer = window.setTimeout(() => saveToStorage(selectEditorState(state)), 200);
  }
  if (state.tab !== lastTab) {
    lastTab = state.tab;
    saveTabToStorage(state.tab);
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
